// Note: This is only for routes the FE needs to inteact with via AJAX
//       All other routes are automatically generated by Rails and
//       manually included via the generate_js_routes rake task
export default {
  submitNewOrderGroupPath() {
    return "/api/merchants/order_groups";
  },
  fetchOrderUnitsPath(productId) {
    return `/api/merchants/order_groups/new?product_id=${productId}`;
  },
  fetchMerchantStoresPath() {
    return "/api/merchants/me/merchant_stores";
  },
  orderGroupsOverviewPath() {
    return "/api/merchants/me/order_groups";
  },
  orderGroupDetailsPath(id) {
    return `/api/merchants/me/order_groups/${id}`;
  },
  uploadPresignPath() {
    return "/api/merchants/uploads/presign";
  },
  listHotOrderUnits(notificationId) {
    return `/api/merchants/hot_order_units?notification_id=${notificationId}`;
  },
  getCurrentBannerPath() {
    return "/api/merchants/banner/current";
  },
  productsOverviewPath(query) {
    return `/api/merchants/products/${query}`;
  },
  submitOrderValidationRequestPath() {
    return "/api/merchants/order-validation";
  },
  regionalProductsOverviewPath() {
    return "/api/merchants/regional_products";
  },

  // TODO: endpoints don't exist yet, so just pulling something
  // else so that isFething isn't always true.
  externalOrdersPath() {
    return `/api/merchants/me/order_groups`;
  },
  externalOrderPath(id) {
    return `/api/merchants/me/order_groups/${id}`;
  },
};
